import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

var epsIcon = function epsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M128 0a32.09 32.09 0 0 0-32 32v448a32.09 32.09 0 0 0 32 32h320a32.09 32.09 0 0 0 32-32V128L352 0z",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 128h96L352 0v96a32.09 32.09 0 0 0 32 32z",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cad1d8",
    d: "M480 224l-96-96h96v96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 416a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V256a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16z",
    fill: "#4bb7e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 432H96v16h304a16 16 0 0 0 16-16v-16a16 16 0 0 1-16 16z",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 313v19.93c1.17.08 2.29.21 3.41.21h31.32c3.19 0 5.69 1.2 7.14 4.16a6.87 6.87 0 0 1-.48 7.21c-1.53 2.32-3.76 3.18-6.51 3.16-10.44-.05-20.88.08-31.32-.07-2.82 0-4 .51-3.82 3.66a142.69 142.69 0 0 1 0 14.33c-.09 2.52.58 3.37 3.23 3.34 11-.15 22.05-.1 33.07 0a12.9 12.9 0 0 1 4.83.84 7.57 7.57 0 0 1 4.34 7.88 8.19 8.19 0 0 1-7.2 6.7 14.61 14.61 0 0 1-1.75.05h-46.54c-6 0-8.43-2.33-8.44-8.28q-.08-35.26 0-70.54c0-5.79 2.3-8.08 8-8.1 15.42-.05 30.83 0 46.25 0 3.29 0 5.87 1.21 7.47 4.18a7.19 7.19 0 0 1-.29 7.77 8 8 0 0 1-7.22 3.63h-31.9zM304.87 295.47c6 .44 11.74 1 17.25 3.35a27.14 27.14 0 0 1 11.44 9.26c3.2 4.37 2.7 9.54-1 12.3s-9.1 1.67-12.4-2.47a20.34 20.34 0 0 0-24.37-6.24c-3.25 1.4-5.27 3.69-5.51 7.25a7.45 7.45 0 0 0 4.06 7.56c4.35 2.12 9 3.71 13.48 5.48 5.7 2.23 11.56 4.12 17.11 6.68 9.37 4.33 14.31 11.71 13.93 22.28s-5.76 18-15.46 21.66c-13.53 5.17-27.21 5.12-40.1-2-4.1-2.25-7.56-6.06-10.6-9.75-2.5-3.05-1.76-7.25.6-10a7.57 7.57 0 0 1 8.76-2.2 11.88 11.88 0 0 1 4.57 3.43c6.6 8.27 15.14 10.44 25.12 8.33 4.79-1 7.9-4 8.37-7.85.57-4.63-1.79-7.87-5.67-9.62-5.57-2.52-11.45-4.35-17.11-6.69a128.93 128.93 0 0 1-13.5-6.23c-9.16-5.09-13-13.11-11.77-23.48 1.14-9.21 7.87-16.24 18.12-18.72 4.81-1.12 9.81-1.56 14.68-2.33zM188.27 341.52v-33.94c0-6.76 3.29-10.14 10-10.13 11.5 0 23-.35 34.5.38 15.51 1 27.09 15.69 25.39 31.18-1.84 16.71-12.83 26.67-29.68 26.82-6.34.06-12.69.2-19-.06-3.11-.13-3.78 1-3.67 3.81.21 5.46.08 10.92 0 16.38 0 6.17-3.28 9.79-8.74 9.81s-8.82-3.64-8.84-9.73c.02-11.51.04-23.04.04-34.52zm17.59-.43c7.81 0 15.25.58 22.55-.17s12.22-7.48 12.07-14.66c-.16-7.94-6.65-14-15.55-14.27-5.45-.16-10.92.06-16.37-.09-2.32-.06-2.76.89-2.73 2.94.09 7 0 14 0 21.06z",
    fill: "#fff"
  }));
};

epsIcon.defaultProps = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
};

var heicIcon = function heicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "heic"), /*#__PURE__*/React.createElement("path", {
    d: "M128 0a32.09 32.09 0 0 0-32 32v448a32.09 32.09 0 0 0 32 32h320a32.09 32.09 0 0 0 32-32V128L352 0z",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 128h96L352 0v96a32.09 32.09 0 0 0 32 32z",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cad1d8",
    d: "M480 224l-96-96h96v96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 416a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V256a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16z",
    fill: "#29cc96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 432H96v16h304a16 16 0 0 0 16-16v-16a16 16 0 0 1-16 16z",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.34 306.12v25h38.19v-25q0-5.36 2.41-8a8.11 8.11 0 0 1 6.34-2.68 8.47 8.47 0 0 1 6.47 2.65q2.48 2.65 2.47 8.07v68.81q0 5.42-2.5 8.1a8.4 8.4 0 0 1-6.44 2.68 8 8 0 0 1-6.37-2.71q-2.39-2.72-2.38-8.07v-29.41H98.34v29.37q0 5.42-2.5 8.1a8.39 8.39 0 0 1-6.43 2.68A8.07 8.07 0 0 1 83 383q-2.39-2.72-2.38-8.07v-68.81q0-5.36 2.35-8a8.09 8.09 0 0 1 6.41-2.68 8.45 8.45 0 0 1 6.46 2.65q2.51 2.62 2.5 8.03zM230.77 310.53h-39.85V332h36.69q4 0 6 1.81a6.19 6.19 0 0 1 2 4.8 6.43 6.43 0 0 1-2 4.86q-2 1.88-6.08 1.87h-36.61v24.84h41.22q4.17 0 6.28 1.94a6.65 6.65 0 0 1 2.12 5.15 6.52 6.52 0 0 1-2.12 5q-2.11 1.93-6.28 1.93h-48.08q-5.77 0-8.31-2.56c-1.68-1.71-2.53-4.47-2.53-8.28v-65.63a14.78 14.78 0 0 1 1.13-6.22 7.08 7.08 0 0 1 3.55-3.51 15 15 0 0 1 6.16-1.1h46.71q4.23 0 6.28 1.88a6.34 6.34 0 0 1 2.06 4.91 6.42 6.42 0 0 1-2.06 5q-2.05 1.85-6.28 1.84zM255.31 374.93v-68.81q0-5.36 2.44-8a8.16 8.16 0 0 1 6.32-2.68 8.45 8.45 0 0 1 6.46 2.65q2.48 2.65 2.47 8.07v68.81q0 5.42-2.47 8.1a8.37 8.37 0 0 1-6.46 2.68 8.14 8.14 0 0 1-6.29-2.71q-2.47-2.75-2.47-8.11zM367.18 356.64a23.31 23.31 0 0 1-2.05 9 33.05 33.05 0 0 1-17.72 17.12 40.42 40.42 0 0 1-16 2.92 56 56 0 0 1-12.57-1.31 35 35 0 0 1-10.27-4.08 34.65 34.65 0 0 1-8.49-7.3 43.29 43.29 0 0 1-5.9-9.2 47.79 47.79 0 0 1-3.63-10.79 59 59 0 0 1-1.22-12.28 54.58 54.58 0 0 1 3.06-18.88 40.48 40.48 0 0 1 8.79-14.27 38.26 38.26 0 0 1 13.4-9A43.35 43.35 0 0 1 331 295.4a41 41 0 0 1 18.89 4.23 34.21 34.21 0 0 1 12.69 10.46q4.41 6.23 4.41 11.76a7.66 7.66 0 0 1-2.15 5.36 6.8 6.8 0 0 1-5.18 2.33 7.19 7.19 0 0 1-5.1-1.61 22.5 22.5 0 0 1-3.78-5.54 26.54 26.54 0 0 0-8.13-9.71 19.83 19.83 0 0 0-11.53-3.22 20.89 20.89 0 0 0-17.36 8.28q-6.47 8.28-6.46 23.53 0 10.19 2.86 17a21.35 21.35 0 0 0 8.1 10.1 22.37 22.37 0 0 0 12.27 3.33 21.58 21.58 0 0 0 12.9-3.78 22.91 22.91 0 0 0 7.95-11.11 18.84 18.84 0 0 1 2.8-5.63q1.67-2.17 5.36-2.17a7.5 7.5 0 0 1 5.42 2.2 7.34 7.34 0 0 1 2.22 5.43z",
    fill: "#fff"
  }));
};

heicIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var pdfIcon = function pdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 128h96L352 0v96c0 17.6 14.4 32 32 32z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M480 224l-96-96h96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.744 303.152c0-4.224 3.328-8.832 8.688-8.832h29.552c16.64 0 31.616 11.136 31.616 32.48 0 20.224-14.976 31.488-31.616 31.488h-21.36v16.896c0 5.632-3.584 8.816-8.192 8.816-4.224 0-8.688-3.184-8.688-8.816v-72.032zm16.88 7.28v31.872h21.36c8.576 0 15.36-7.568 15.36-15.504 0-8.944-6.784-16.368-15.36-16.368h-21.36zM196.656 384c-4.224 0-8.832-2.304-8.832-7.92v-72.672c0-4.592 4.608-7.936 8.832-7.936h29.296c58.464 0 57.184 88.528 1.152 88.528h-30.448zm8.064-72.912V368.4h21.232c34.544 0 36.08-57.312 0-57.312H204.72zM303.872 312.112v20.336h32.624c4.608 0 9.216 4.608 9.216 9.072 0 4.224-4.608 7.68-9.216 7.68h-32.624v26.864c0 4.48-3.184 7.92-7.664 7.92-5.632 0-9.072-3.44-9.072-7.92v-72.672c0-4.592 3.456-7.936 9.072-7.936h44.912c5.632 0 8.96 3.344 8.96 7.936 0 4.096-3.328 8.704-8.96 8.704h-37.248v.016z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z",
    fill: "#CAD1D8"
  }));
};

pdfIcon.defaultProps = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
};

var svgIcon = function svgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0", `{`, "fill:#e2e5e7", `}`, ".st1", `{`, "fill:#b0b7bd", `}`, ".st2", `{`, "fill:#cad1d8", `}`, ".st3", `{`, "fill:#faaf40", `}`, ".st4", `{`, "fill:#fff", `}`), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128 0c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128L352 0H128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384 128h96L352 0v96c0 17.7 14.3 32 32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M480 224l-96-96h96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M169.3 353.7c0 5.4-1.4 10.2-4.1 14.5-2.8 4.3-6.8 7.6-12.1 10.1s-11.6 3.6-19 3.6c-8.8 0-16-1.7-21.7-5-4-2.4-7.3-5.6-9.8-9.5-2.5-4-3.8-7.8-3.8-11.6 0-2.2.8-4 2.3-5.6 1.5-1.6 3.4-2.3 5.8-2.3 1.9 0 3.5.6 4.8 1.8 1.3 1.2 2.4 3 3.4 5.4 1.1 2.8 2.4 5.2 3.7 7.1 1.3 1.9 3.2 3.5 5.5 4.7 2.4 1.2 5.5 1.8 9.4 1.8 5.3 0 9.7-1.2 13-3.7s5-5.6 5-9.3c0-2.9-.9-5.3-2.7-7.2-1.8-1.8-4.1-3.2-7-4.2s-6.7-2-11.4-3.1c-6.4-1.5-11.7-3.2-16-5.2s-7.7-4.7-10.2-8.2c-2.5-3.5-3.8-7.7-3.8-12.9 0-4.9 1.3-9.2 4-13s6.5-6.7 11.6-8.7c5-2 11-3.1 17.8-3.1 5.4 0 10.2.7 14.1 2 4 1.4 7.3 3.1 9.9 5.4 2.6 2.2 4.5 4.6 5.8 7.1s1.8 4.9 1.8 7.2c0 2.1-.8 4.1-2.3 5.8-1.5 1.7-3.4 2.6-5.7 2.6-2.1 0-3.6-.5-4.7-1.5s-2.2-2.7-3.5-5.1c-1.6-3.4-3.6-6-5.8-7.8-2.3-1.9-5.9-2.8-10.9-2.8-4.6 0-8.4 1-11.2 3.1-2.8 2-4.3 4.5-4.3 7.4 0 1.8.5 3.3 1.5 4.6s2.3 2.4 4 3.3 3.4 1.7 5.1 2.2c1.7.5 4.6 1.3 8.6 2.3 5 1.2 9.5 2.5 13.6 3.9s7.5 3.1 10.4 5.1 5.1 4.6 6.7 7.7c1.4 2.9 2.2 6.7 2.2 11.1zM197.7 301.9l20.1 59.5 20.2-59.9c1-3.1 1.8-5.3 2.4-6.6.5-1.2 1.4-2.3 2.6-3.3 1.2-1 2.9-1.5 5-1.5 1.5 0 3 .4 4.3 1.2 1.3.8 2.3 1.8 3.1 3.1.7 1.3 1.1 2.6 1.1 3.8 0 .9-.1 1.8-.4 2.9s-.5 2-.9 3-.7 2-1.1 3.1l-21.5 58c-.8 2.2-1.5 4.3-2.3 6.3-.8 2-1.7 3.8-2.7 5.3-1 1.5-2.4 2.8-4 3.7-1.7 1-3.7 1.5-6.1 1.5s-4.5-.5-6.1-1.4c-1.7-.9-3-2.2-4.1-3.8-1-1.6-1.9-3.3-2.7-5.3-.8-2-1.5-4.1-2.3-6.3L181 307.6c-.4-1-.7-2.1-1.1-3.1-.4-1-.7-2.1-1-3.3-.3-1.2-.4-2.2-.4-3 0-2.1.8-3.9 2.5-5.6 1.7-1.7 3.7-2.5 6.2-2.5 3.1 0 5.2.9 6.5 2.8s2.6 4.9 4 9zM349.3 344.3v17c0 2.3-.2 4.1-.7 5.4-.4 1.4-1.3 2.6-2.5 3.7s-2.7 2.1-4.6 3.1c-5.4 2.9-10.5 5-15.5 6.4s-10.4 2-16.2 2c-6.8 0-13-1-18.6-3.1-5.6-2.1-10.4-5.1-14.3-9.1-4-4-7-8.8-9.1-14.5s-3.2-12-3.2-19.1c0-6.9 1-13.2 3.1-19s5.1-10.6 9.1-14.6 8.9-7.1 14.6-9.2c5.7-2.1 12.2-3.2 19.5-3.2 6 0 11.3.8 15.9 2.4 4.6 1.6 8.3 3.6 11.2 6 2.9 2.4 5 5 6.5 7.7s2.2 5.1 2.2 7.2c0 2.3-.8 4.2-2.5 5.8-1.7 1.6-3.7 2.4-6 2.4-1.3 0-2.5-.3-3.7-.9-1.2-.6-2.2-1.5-3-2.5-2.2-3.5-4.1-6.1-5.6-7.9-1.5-1.8-3.6-3.3-6.2-4.5s-5.9-1.8-10-1.8c-4.2 0-7.9.7-11.1 2.1-3.3 1.4-6.1 3.5-8.4 6.2-2.3 2.7-4.1 6.1-5.3 10-1.2 4-1.8 8.3-1.8 13.1 0 10.4 2.4 18.4 7.2 24 4.8 5.6 11.5 8.4 20 8.4 4.2 0 8.1-.5 11.7-1.6 3.7-1.1 7.4-2.6 11.1-4.7v-14.4h-13.9c-3.4 0-5.9-.5-7.6-1.5-1.7-1-2.6-2.7-2.6-5.1 0-2 .7-3.6 2.1-4.9 1.4-1.3 3.4-1.9 5.8-1.9h20.4c2.5 0 4.6.2 6.4.7 1.7.4 3.1 1.4 4.2 3 .8 1.5 1.4 3.8 1.4 6.9z"
  }));
};

svgIcon.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var fallbackIcon = function fallbackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "unknown"), /*#__PURE__*/React.createElement("path", {
    d: "M128 0a32.09 32.09 0 0 0-32 32v448a32.09 32.09 0 0 0 32 32h320a32.09 32.09 0 0 0 32-32V128L352 0z",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 128h96L352 0v96a32.09 32.09 0 0 0 32 32z",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cad1d8",
    d: "M480 224l-96-96h96v96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 416a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V256a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16z",
    fill: "#8792b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 432H96v16h304a16 16 0 0 0 16-16v-16a16 16 0 0 1-16 16z",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.59 317.08a21.52 21.52 0 0 1 3.64-11.47 28 28 0 0 1 10.6-9.62 33.39 33.39 0 0 1 16.26-3.81 34.65 34.65 0 0 1 15.25 3.19 24.7 24.7 0 0 1 10.22 8.63 21.25 21.25 0 0 1 3.6 11.91 18.45 18.45 0 0 1-2 8.88 27.17 27.17 0 0 1-4.89 6.58q-2.82 2.76-10.15 9.32a38 38 0 0 0-3.25 3.25 12.83 12.83 0 0 0-1.82 2.56 12.44 12.44 0 0 0-.92 2.32c-.22.78-.55 2.14-1 4.08q-1.14 6.19-7.09 6.2a7.26 7.26 0 0 1-5.22-2q-2.11-2-2.11-6a21.16 21.16 0 0 1 5.63-15.1q2.57-2.76 6.91-6.58 3.81-3.33 5.51-5a17.26 17.26 0 0 0 2.86-3.78 9.2 9.2 0 0 0 1.16-4.53 10.52 10.52 0 0 0-3.54-8 13 13 0 0 0-9.15-3.28q-6.56 0-9.65 3.31a26.4 26.4 0 0 0-5.24 9.74q-2 6.72-7.69 6.73a7.53 7.53 0 0 1-5.62-2.36 7.17 7.17 0 0 1-2.3-5.17zm29.07 65.29a9.35 9.35 0 0 1-6.34-2.35 8.26 8.26 0 0 1-2.71-6.59 8.47 8.47 0 0 1 2.62-6.31 8.84 8.84 0 0 1 6.43-2.56 8.74 8.74 0 0 1 8.88 8.87 8.36 8.36 0 0 1-2.68 6.56 9.06 9.06 0 0 1-6.2 2.38z",
    fill: "#fff"
  }));
};

fallbackIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};
import { Image as StyledImage } from './Image';
const fileIcons = {
  pdf: pdfIcon,
  eps: epsIcon,
  svg: svgIcon,
  heic: heicIcon
};
const StyledProgressiveImage = styled(StyledImage).withConfig({
  displayName: "ProgressiveImage__StyledProgressiveImage",
  componentId: "sc-1dcx29u-0"
})(["filter:", ";clip:", ";margin:0 auto;transition:all 0.25s ", ";transform-origin:center center;min-width:", ";cursor:pointer;"], x => `blur(${x.$loaded ? '0' : x.$blur})`, x => `rect(${x.$loaded ? '0, 0, 0, 0' : `${x.$blur}, ${x.$blur}, ${x.$blur}, ${x.$blur}`})`, x => x.theme.curves.standard, x => x.maskWidth);
const FileName = styled.div.withConfig({
  displayName: "ProgressiveImage__FileName",
  componentId: "sc-1dcx29u-1"
})(["font-size:", ";text-align:center;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;"], x => x.theme.type.scale[8]);
const StyledIcon = styled.div.withConfig({
  displayName: "ProgressiveImage__StyledIcon",
  componentId: "sc-1dcx29u-2"
})(["width:", "px;height:", "px;cursor:pointer;"], x => x.$width, x => x.$height);
export const sizes = {
  xs: 16,
  ss: 160,
  sm: 160,
  md: 320,
  lg: 640,
  xl: 1024
};
export const ProgressiveImage = ({
  file,
  fileUrl,
  disableBlur,
  onClick,
  onLoad,
  size,
  placeholderSize,
  sourceUrl,
  thumbSize,
  title
}) => {
  const [naturalHeight, setNaturalHeight] = useState(0);
  const [naturalWidth, setNaturalWidth] = useState(0);
  const [sizeState, setSizeState] = useState('xs');
  const [windowState, setWindowState] = useState();
  const [img, setImg] = useState();
  const setDimensions = useCallback((height, width) => {
    setNaturalHeight(height);
    setNaturalWidth(width);
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined' && !windowState) setWindowState(window);
  }, [windowState]);
  const checkValidImage = useCallback(extension => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'webp'];
    return imageExtensions.includes(extension.toLowerCase());
  }, []);
  const isImage = useMemo(() => file ? checkValidImage(file.extension) : !!(naturalWidth || naturalHeight), [checkValidImage, file, naturalHeight, naturalWidth]);
  const imgSrcFromFile = useMemo(() => {
    if (!file) return '';
    const sizeTag = (size || sizeState === 'xs') && isImage ? `_size=${size || sizeState}` : '';
    return file ? `${fileUrl}/${file.id}${sizeTag}.${file.extension}` : '';
  }, [file, fileUrl, isImage, size, sizeState]);
  useEffect(() => {
    if (!img) setImg(new Image());

    if (img) {
      img.src = sourceUrl || imgSrcFromFile;

      img.onload = () => setSizeState(size);

      const interval = setInterval(() => {
        if (img.naturalWidth && img.naturalHeight) {
          clearInterval(interval);
          setDimensions(img.naturalHeight, img.naturalWidth);
          onLoad == null ? void 0 : onLoad();
        }

        if (img.height === 0) clearInterval(interval);
      }, 100);

      img.onerror = () => clearInterval(interval);

      return () => clearInterval(interval);
    }
  }, [file, fileUrl, onLoad, size, sourceUrl, setDimensions, imgSrcFromFile, img]);
  const src = useMemo(() => {
    const sizeTag = (size || sizeState === 'xs') && isImage ? `_size=${size || sizeState}` : '';
    return sourceUrl || (file ? `${fileUrl}/${file.id}${sizeTag}.${file.extension}` : '');
  }, [file, fileUrl, isImage, size, sizeState, sourceUrl]);
  const isPortrait = useMemo(() => naturalHeight > naturalWidth, [naturalHeight, naturalWidth]);
  const {
    renderedHeight,
    renderedWidth
  } = useMemo(() => {
    return {
      renderedHeight: placeholderSize && sizes[placeholderSize] || naturalHeight || sizes[sizeState],
      renderedWidth: placeholderSize && sizes[placeholderSize] || naturalWidth || sizes[sizeState]
    };
  }, [placeholderSize, naturalHeight, sizeState, naturalWidth]); // use ratios to keep proportion of dimensions

  const {
    finalHeight,
    finalWidth
  } = useMemo(() => {
    return isPortrait ? {
      finalHeight: renderedHeight,
      finalWidth: renderedWidth * (naturalWidth / naturalHeight)
    } : {
      finalHeight: renderedHeight * (naturalHeight / naturalWidth),
      finalWidth: renderedWidth
    };
  }, [isPortrait, renderedWidth, naturalWidth, naturalHeight, renderedHeight]);
  const blurAmount = useMemo(() => disableBlur || sizeState !== 'xs' ? '0' : `${finalWidth / 10}px`, [disableBlur, sizeState, finalWidth]); // Set a default title if no title is provided

  const finalTitle = useMemo(() => {
    if (!title) {
      const date = (file == null ? void 0 : file.metadata.uploadedOn) || '';
      const dateStr = date instanceof Date ? `${date.toLocaleDateString()} ${date.toLocaleTimeString()}` : '';
      return `${(file == null ? void 0 : file.metadata.title) || ''}${dateStr ? `, ${dateStr}` : ''}`;
    }

    return title;
  }, [title, file]);
  return isImage ? /*#__PURE__*/React.createElement(StyledProgressiveImage, {
    $blur: blurAmount,
    $loaded: !sizeState || sizeState !== 'xs',
    alt: finalTitle,
    height: `${finalHeight}px`,
    masked: Boolean(thumbSize),
    maskHeight: thumbSize ? `${thumbSize}px` : undefined,
    maskWidth: thumbSize ? `${thumbSize}px` : undefined,
    onClick: onClick,
    src: src,
    title: finalTitle,
    width: `${finalWidth}px`
  }) : file ? /*#__PURE__*/React.createElement(StyledIcon, {
    $width: thumbSize || finalWidth,
    $height: thumbSize || finalHeight,
    onClick: () => windowState == null ? void 0 : windowState.open(src),
    title: `Bekijk of download ${finalTitle}.${file.extension}`
  }, /*#__PURE__*/React.createElement(fileIcons[file.extension] || fallbackIcon, {
    title: finalTitle
  }), /*#__PURE__*/React.createElement(FileName, null, file.metadata.title)) : /*#__PURE__*/React.createElement(React.Fragment, null);
};